import React, { useContext, useState } from "react";
import { sendInquiryDataInRedirect } from "../../components/sendInquiry";
import {
  CLASS_HOLDER_CORE_SELECTION,
  CLASS_ITEM_CORE_SELECTION,
} from "../../helpers/constants";
import { toogleCheckboxCheckClassName } from "../../helpers/shared";
import { APP_VARIANTS_ENUM } from "../../models/appSettings";
import { PropertiesGroup as PropertiesGroupType } from "../../models/API";
import { CompareProductProps as CompareProductPropsBase } from "../../models/comapreResults";
import { StaticSettingsAppContext } from "../App/App";
import { scrollToRef } from "../../helpers/scrollToRef";
import { DictionaryType } from "../../models/shared";

import "./index.css";

interface CompareProductProps extends CompareProductPropsBase {
  dictionary: DictionaryType;
  inquiryUrl: string;
}

export const CompareProducts = (props: CompareProductProps) => {
  const STATIC_SETTINGS_APP = useContext(StaticSettingsAppContext);
  const [inquiryData, setInquiryData] = useState([]);

  const scrollToTopApp = scrollToRef(STATIC_SETTINGS_APP.APP_REF);

  const setCompareVisible = () => {
    props.setCompareResults({ view: false, results: [] });
    scrollToTopApp();
  };
  const selectForInquiry = (variantId) => {
    if (typeof variantId === "number") {
      variantId = variantId.toString();
    }
    const indexOfSelected = inquiryData.findIndex((val) => val === variantId);
    const _inquiryData = inquiryData.slice();
    if (indexOfSelected >= 0) {
      _inquiryData.splice(indexOfSelected, 1);
    } else {
      _inquiryData.push(variantId);
    }
    setInquiryData(_inquiryData);
  };

  const HeaderRow = (propertyGroup: PropertiesGroupType) =>
    STATIC_SETTINGS_APP.APP_VARIANT === APP_VARIANTS_ENUM.FINISHING_GUIDE && (
      <b>{propertyGroup.GroupName}: </b>
    );

  const CompareElements = props.compareResults.results.map(
    (compareElement, index) => (
      <React.Fragment key={`${index}-Key`}>
        <div className="divider" />
        <div className="col">{compareElement.VariantName}</div>
      </React.Fragment>
    )
  );

  const PropertiesData = props.compareResults.results[0].PropertiesGroups.map(
    (propertyGroup, indexGroup) =>
      propertyGroup.Properties.map((property) => (
        <div className="row" key={`key-${indexGroup}-${property.NameId}`}>
          <div className="col">
            <HeaderRow {...propertyGroup} />
            {property.DisplayName}
          </div>
          <div className="col">{property.Unit}</div>
          <div className="divider" />
          {props.compareResults.results.map((result) => {
            // match single property based on header row
            const foundValue = result.PropertiesGroups[
              indexGroup
            ].Properties.find(
              (prop) => prop.DisplayName === property.DisplayName
            );
            return (
              <React.Fragment>
                <div className="col">{foundValue.Value}</div>
                <div className="divider" />
              </React.Fragment>
            );
          })}
        </div>
      ))
  );

  const InquiryCheckboxes = props.compareResults.results.map(
    (compareElement) => (
      <React.Fragment key={`${compareElement.Id}checkbox`}>
        <div className="divider" />
        <div className="col checkbox inquiry">
          <i
            className={toogleCheckboxCheckClassName(
              inquiryData,
              compareElement.Id
            )}
            data-variantid={compareElement.Id}
            onClick={() => {
              selectForInquiry(compareElement.Id);
            }}
          />
        </div>
      </React.Fragment>
    )
  );

  return (
    <div className={CLASS_HOLDER_CORE_SELECTION}>
      <div className="column compare-holder">
        <div className="results-holder">
          <div className="items">
            <div className={CLASS_ITEM_CORE_SELECTION}>
              <div className="item-list-holder">
                <div className="row header">
                  <div className="col"></div>
                  <div className="col"></div>
                  {CompareElements}
                  <div className="divider" />
                </div>

                {PropertiesData}

                <div className="row">
                  <div className="col">
                    <b>{props.dictionary.InquiryText}</b>
                  </div>
                  <div className="col" />
                  {InquiryCheckboxes}
                  <div className="divider" />
                </div>
                <div className="row" />
              </div>
            </div>
          </div>
          <div className="CTA-holder">
            <button className="no-button" onClick={setCompareVisible}>
              {props.dictionary.BackToResultsText}
            </button>
            <button
              className="button"
              onClick={() => {
                sendInquiryDataInRedirect({
                  dataForInquiry: inquiryData,
                  inquiryUrl: props.inquiryUrl,
                });
              }}
            >
              {props.dictionary.MakeInquiryText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
